import {
  buildPaymentSummaryQuery,
  hasRequiredFilterKeys,
  paymentSummaryCardsFromResponse,
} from "@/components/receipt-payment-summary/payment-summary-factory";
import type {
  PaymentSummaryCardView,
  PaymentSummaryResponse,
} from "@/components/receipt-payment-summary/types";

export const LAGAT_SUMMARY_QUERY_KEYS = ["startDate", "endDate", "paymentMode", "q"] as const;

export type LagatSummaryQueryKey = (typeof LAGAT_SUMMARY_QUERY_KEYS)[number];

export const LAGAT_PAYMENT_SUMMARY_PATH = "lagatReceipts/summary/payment-mode";

export const LAGAT_SUMMARY_REQUIRED_DATE_KEYS = ["startDate", "endDate"] as const;

export function buildLagatSummaryQuery(filterValues: Record<string, unknown>): URLSearchParams {
  return buildPaymentSummaryQuery(filterValues, LAGAT_SUMMARY_QUERY_KEYS);
}

export function shouldFetchLagatPaymentSummary(filterValues: Record<string, unknown>): boolean {
  return hasRequiredFilterKeys(filterValues, LAGAT_SUMMARY_REQUIRED_DATE_KEYS);
}

export function lagatPaymentSummaryCardsFromResponse(
  summary: PaymentSummaryResponse
): PaymentSummaryCardView[] {
  return paymentSummaryCardsFromResponse(summary);
}
